import { getError } from "@/utils/helpers";
import StatuteService from "@/services/statute/StatuteService";

export const namespaced = true;

export const state = {
  results: [],
  loading: false,
  error: null,
};

export const mutations = {
  SET_RESULT(state, results) {
    state.results = results;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

export const actions = {
  getStatus({ commit }, famId) {
    commit("SET_LOADING", true);

    StatuteService.getAllResults(famId)
      .then((response) => {
        commit("SET_RESULT", response.data.data);
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", getError(error));
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },
  setDefault({ commit }) {
    commit("SET_LOADING", false);
    commit("SET_ERROR", null);
    commit("SET_RESULT", []);
  },
};
export const getters = {
  results: (state) => {
    return state.results;
  },
  loading: (state) => {
    return state.loading;
  },
  error: (state) => {
    return state.error;
  },
};
